export const playerAvatarImgClassName =
	'rounded-full border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg object-cover';

/** Wrapper — byte-for-byte same as PlayersProfileStatsTable. */
export const playerListAvatarWrapperStyle = {
	width: '50px',
	height: '50px',
	overflow: 'hidden',
	marginRight: '8px'
};

/** Img dimensions — same as PlayersProfileStatsTable. */
export const playerListAvatarImgDimensionsStyle = {
	width: '50px',
	height: '50px',
	minWidth: '50px',
	minHeight: '50px'
};

export const searchResultAvatarClassName =
	'relative mr-2 shrink-0 rounded-full border border-gray-200 dark:border-dark-border bg-white dark:bg-dark-bg';

export const compareModalSearchResultAvatarClassName =
	'relative mr-2 shrink-0 rounded-full border border-dark-border bg-dark-bg';
